module.exports = __webpack_public_path__ + "img/fa4ac46e75d7424601358f1a240e75344a82bf53.ff76859f.jpg";